import React from "react";
import MarketingPage from "@/components/MarketingPage";

export default function ToolTextbookSummarizer() {
  return (
    <MarketingPage
      testid="tool-textbook-summarizer"
      tag="ai study tool"
      h1="AI Textbook Summarizer for Students"
      intro="Loom is an AI textbook summarizer that turns dense chapters into clear, horizontal review slides. Upload a textbook PDF and get a walk-through deck of concise summaries, key points and quizzes — so you can revise a whole chapter in a single focused sitting."
      ctaText="Summarize my textbook"
      sections={[
        {
          h2: "From heavy chapters to horizontal review slides",
          body: [
            "Reading a textbook cover to cover is slow and easy to forget. Loom's AI textbook summarizer reads your chapter and rebuilds it as a horizontal deck of review slides — one idea per card — so instead of scrolling one long vertical wall of text, you move sideways through the key concepts in order.",
            "Each slide gives you a tight summary, the must-remember points highlighted, and a deeper recall paragraph for the parts that are genuinely tricky. The result is a chapter you can actually hold in your head, not just a document you have skimmed.",
          ],
        },
        {
          h2: "How Loom summarizes a textbook chapter",
          body: [
            "Upload a chapter or an entire textbook PDF. Loom's AI identifies the structure, strips the filler, and converts each section into a clean review slide with a summary and the essential takeaways. You keep the depth where it matters and lose the padding that slows revision down.",
            "Every summary links back to the page it came from in the original PDF, so you can verify anything in a tap. When you are ready to test yourself, Loom generates flashcards, MCQs and recall prompts from the same chapter — turning passive reading into active study.",
          ],
        },
        {
          h2: "Built for exam season",
          body: [
            "Whether you are revising for university finals, a competitive entrance exam or a professional certification, condensing chapters into review slides is one of the fastest ways to cover more ground in less time. Start free, summarize your first chapters with no card required, and export any review deck to PDF or PowerPoint to study offline or share with your group.",
          ],
        },
      ]}
    />
  );
}
